import { Address, getContract, PublicClient, WalletClient } from 'viem';

import stakingPoolAbi from 'modules/api/abi/DelegateStakingPool';

export function getDelegateStakingPoolContract(
  client: WalletClient | PublicClient,
  poolAddress: Address,
) {
  return getContract({
    address: poolAddress,
    abi: stakingPoolAbi,
    client,
  });
}
